export default __webpack_public_path__ + "static/media/Portfolio-RyanAdiSaputraNew.6b671877.pdf";